<template>
  <div class="countdown-wrapper">
    <svg>
      <use xlink:href="#icon-new-clock"></use>
    </svg>
    <div class="right">
      <div class="txt">
        Promo <i>flash</i>
      </div>
      <div class="time">
        <template v-if="days">
          <span>{{ days }}</span>j
        </template>
        <span>{{ hours }}</span>h
        <span>{{ minutes }}</span>m
        <span>{{ seconds }}</span>s
      </div>
    </div>
  </div>
</template>
<script>
import differenceInDays from 'date-fns/differenceInDays'
import differenceInHours from 'date-fns/differenceInHours'
import differenceInMinutes from 'date-fns/differenceInMinutes'
import differenceInSeconds from 'date-fns/differenceInSeconds'
import subDays from 'date-fns/subDays'
import subHours from 'date-fns/subHours'
import subMinutes from 'date-fns/subMinutes'
import endOfDay from 'date-fns/endOfDay'

export default {
  name: 'OffersCountdown',
  props: {
    end: {
      type: [String, Date],
      required: true,
    },
  },
  watch: {
    seconds() {
      if (this.date > this.now) {
        return
      }

      return this.$emit('expired')
    },
  },
  computed: {
    now() {
      return this.$store.state.offers.now
    },
    date() {
      return endOfDay(new Date(this.end))
    },
    days() {
      return differenceInDays(this.date, this.now)
    },
    minusDays() {
      return subDays(this.date, this.days)
    },
    hours() {
      return differenceInHours(this.minusDays, this.now).toString().padStart(2, '0')
    },
    minusDaysHours() {
      return subHours(this.minusDays, this.hours)
    },
    minutes() {
      return differenceInMinutes(this.minusDaysHours, this.now).toString().padStart(2, '0')
    },
    minusDaysHoursMinutes() {
      return subMinutes(this.minusDaysHours, this.minutes)
    },
    seconds() {
      return differenceInSeconds(this.minusDaysHoursMinutes, this.now).toString().padStart(2, '0')
    },
  },
}
</script>
<style lang="scss" scoped>

.countdown-wrapper {
  align-items: stretch;
  background: $c-mine-shaft;
  color: white;
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
}

.right {
  align-items: center;
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  font-family: $f-graphie-lt;
  justify-content: space-between;

  @include font-size(32px);
}

.txt {
  color: white;
  font-family: $f-graphie-book;
  text-transform: uppercase;

  @include font-size(24px);
}

i {
  color: $sunglow;
  font-style: italic;
}

span {
  font-family: $f-graphie-book;
}

svg {
  align-self: center;
  fill: $sunglow;
  height: 40px;
  margin: 0 20px 0 0;
  width: 40px;
}
</style>
